import { render, staticRenderFns } from "./BasemapGallery.vue.js?vue&type=template&id=70dec12f!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasemapGallery.vue?vue&type=template&id=70dec12f"
import script from "./BasemapGallery.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasemapGallery.vue?vue&type=script&lang=js"
export * from "./BasemapGallery.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasemapGallery.vue?vue&type=script&lang=js"
import style0 from "./BasemapGallery.vue.scss?vue&type=style&index=0&id=70dec12f&prod&lang=scss!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasemapGallery.vue?vue&type=style&index=0&id=70dec12f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports